import { memo } from "react";
import styles from "./styles.module.scss";
import { Checkbox } from "reusableComponents";

const MoreFiltersItem = memo(({ header, options, onChange, selectedOptions, keySelector }) => {
  if (!options?.length) return null;

  return (
    <section className={styles.container}>
      <h3 className={styles.header}>{header}</h3>
      <div className={styles.optionsWrapper}>
        {options.map((option) => {
          const key = keySelector(option);
          const isChecked = selectedOptions.includes(key);

          const handleChange = () => {
            onChange(option);
          };

          return (
            <div key={key} className={styles.optionWrapper}>
              <Checkbox
                label={option.name}
                isSquare
                checked={isChecked}
                onChange={handleChange}
                className={styles.checkbox}
              />
              {option.count !== undefined && (
                <span className={styles.count}>
                  {option.count}
                </span>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
});

MoreFiltersItem.displayName = "MoreFiltersItem";

export default MoreFiltersItem;